<template>
  <div class="container">
    <el-row style="margin-bottom:20px">
        <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/director-work' }">工作台</el-breadcrumb-item>
        <el-breadcrumb-item >立项</el-breadcrumb-item>
      </el-breadcrumb>
    </el-row>
    <el-form ref="form" :model="searchFormData" :inline="true">

      <el-form-item label="">
        <el-input placeholder="输入项目名称搜索" v-model="searchFormData.search"></el-input>
      </el-form-item>

      <el-form-item label="所属公司">
        <el-select
                v-model="searchFormData.company_app_id"
                clearable
                filterable
                placeholder="请选择"
                style="width:100%"
              >
              <el-option
                v-for="item in companyList"
                :key="item.company_app_id"
                :label="item.company_name"
                :value="item.company_app_id"
              />
        </el-select>
      </el-form-item>

      <el-form-item label="项目状态">
        <el-select v-model="searchFormData.status" 
        clearable
           filterable
        placeholder="请选择">
          <el-option label="未审核" value="0"></el-option>
          <el-option label="已审核" value="1"></el-option>
          <el-option label="已拒绝" value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      </el-form-item>
      <el-form-item style="float: right">
        <el-button type="primary" @click="addProject">提交立项审核</el-button>
      </el-form-item>
    </el-form>

    <div class="table">

      <!-- start -->
      <div class="pro_unit" v-for="(item, index) in pageProps.records" :key="index">
        <div class="pro_a">
          <img :src="item.image" />
        </div>
        <div class="pro_b">
          <div>
            <b>{{ item.name }}</b>
            <span>
              {{ item.company?item.company.company_name:'' }}
            </span>
          </div>
          <p>简介：{{ item.description }}
          </p>
        </div>
       
        
        <div class="pro_c">
          <b>{{ item.job_count }}</b>
          <p>发布的职位</p>
        </div>
        <div class="pro_c">
          <b>{{ item.crowd_num }}</b>
          <p>发布的众包</p>
        </div>

        <div class="pro_c">
          
          <b>{{item.status_type}}</b>
        </div>

        <div class="pro_d" >
          <el-button plain @click="publishDemand(item.project_id)" v-if="item.status==1">发布需求</el-button>
        
          <el-button type="primary" plain @click="projectSetting(item.project_id)" >项目设置</el-button>

        </div>
        <div class="pro_e">
          <el-dropdown>
            <span class="el-dropdown-link">
              更多操作<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item icon="el-icon-edit" style="color:#4C71DB" @click.native="editProject(item)">编辑项目</el-dropdown-item>
              
              <el-dropdown-item icon="el-icon-delete" style="color:#FF4444" @click.native="delProject(item)">删除项目</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      <!-- end -->
    </div>

    <!--分页-->
    <div class="page_box">
      <el-pagination background layout="total, sizes, prev, pager, next, jumper" 
      :total="pageProps.total" 
      :page-sizes="[5, 10, 50, 100]"
      :page-size="pageProps.pageSize" 
      :current-page="pageProps.pageNum" 
      @size-change="handleSizeChange"
       @current-change="handleCurrentChange" />
    </div>

    <project-dialog ref="projectDialog" @refresh="fetchData"></project-dialog>
  </div>
</template>

<script>
import { projectList,companyList,projectInfo,delProject} from "@/api/director/project/index";

import projectDialog from "@/views/director/work/project/project-dialog.vue";

export default {
  components: { projectDialog },

  data () {
    return {
      searchLoading: false,
      pageProps: {
        records: [],
        total: 0,
        pageNum: 1,
        pageSize: 10,
      },
      companyList:[],

      searchFormData: {
        company_app_id: "",
        search: "",
        status: "", //状态0 未审核 1 已审核 2 已拒绝
        page: 0,
        limit: 0,
      },
    };
  },

  mounted () {
    this.initCompanyList();
    this.fetchData();
  },

  methods: {
    search(){
      this.fetchData();
    },

    publishDemand(project_id){
      const routeData = this.$router.resolve({
        name: 'director-demand-publish',
        query:{project_id:project_id} 
      })
      window.open(routeData.href, '_blank')

    },

    projectSetting(project_id){
      //director-work-project-setting
      const routeData = this.$router.resolve({
        name: 'director-work-project-setting',
        query:{project_id:project_id} 
      })
      window.open(routeData.href, '_blank')
    },
    
    fetchData () {
      var that = this;
      that.searchFormData.page = that.pageProps.pageNum;
      that.searchFormData.limit = that.pageProps.pageSize;

      projectList(that.searchFormData).then((response) => {
        console.log(response);
        that.pageProps.records = response.data.data;
        that.pageProps.total = response.data.total;
      });
    },

    initCompanyList(){
      var that = this;
      companyList({}).then((response) => {
        console.log('companyList',response);
        that.companyList = response.data;
      });
    },

    // 当前页变更
    handleCurrentChange (num) {
      this.pageProps.pageNum = num;
      this.fetchData();
    },

    // 每页显示页面数变更
    handleSizeChange (size) {
      this.pageProps.pageSize = size;
      this.fetchData();
    },

    addProject () {
      this.$refs.projectDialog.init();
    },

    editProject(item){
      console.log(item);
      this.$refs.projectDialog.init(item);

    },

    delProject(item){
      var that=this;
        this.$confirm('确定删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }).then(() => {
            const project_id	=item.project_id;
            console.log("project_id",project_id);
            delProject({project_id:project_id}).then((response) => {
              console.log(response);
              if(response.code==200){
                  that.fetchData();
              }
            });
          
        }).catch(() => {
        
        });
    },

  
  },
};
</script>

<style lang="scss" scoped>
.table {
  min-height: 500px;
}
.pro_unit {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fafafa;
  border: 1px solid #cccccc;
  border-radius: 6px;
  margin-bottom: 24px;
  padding: 20px;
  height: 64px;
  font-size: 14px;
  color: #999;
  .pro_a {
    img {
      width: 64px;
      height: 64px;
      object-fit: cover;
      border-radius: 3px;
    }
  }
  .pro_b {
    max-width: 480px;
    min-width: 300px;

    height: 64px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    div {
      b {
        font-size: 20px;
        margin-right: 50px;
        color: #333;
      }
      span {
        color: #4c71db;
      }
    }
    p {
      white-space: nowrap;
      word-break: keep-all;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .pro_c {
    width: 130px;
    text-align: center;
    b {
      color: #333;
      line-height: 30px;
    }
  }
  .pro_d {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    width: 120px;
    height: 80px;

    button{
      width:100px;
      margin:0 auto;
    }
  }
}
.page_box {
  display: flex;
  justify-content: center;
}
</style>